export default __webpack_public_path__ + "static/media/NextProject4.e29c327c.png";